<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <el-form-item label="状态" v-if="props.id">
        <el-switch
          v-model="state.model.status"
          active-text="启用"
          inactive-text="禁用"
          inline-prompt
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
      <el-form-item
        label="类别"
        prop="dictionary_cate_id"
        :rules="[{ required: true, message: '请选择类别', trigger: 'blur' }]"
      >
        <el-select
          v-model="state.model.dictionary_cate_id"
          placeholder="--请选择--"
          @change="onCateChange"
        >
          <el-option
            v-for="item in state.cateData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadCate"
            >
              刷新
            </el-button>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="上级字典">
        <el-tree-select
          v-model="state.model.pid"
          :data="state.treeData"
          node-key="id"
          :props="{
            children: 'children',
            label: 'name',
          }"
          :expand-on-click-node="false"
          clearable
          check-strictly
          default-expand-all
        >
          <template #footer>
            <el-button
              plain
              class="float-right mb-3"
              size="small"
              @click="onLoadTree"
            >
              刷新
            </el-button>
          </template>
        </el-tree-select>
      </el-form-item>
      <el-form-item
        label="名称"
        prop="name"
        :rules="[
          { required: true, message: '请输入部门名称', trigger: 'blur' },
        ]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <el-form-item label="说明">
        <el-input v-model="state.model.description" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="序号">
        <el-input v-model="state.model.sort"></el-input>
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  dictionary_cate_list,
  dictionary_detail,
  dictionary_add,
  dictionary_edit,
  dictionary_tree,
} from "@/http/dictionary";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    cateId: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadCate();
      if (props.cateId) {
        state.model.dictionary_cate_id = props.cateId;
        onLoadTree();
      }

      if (props.id) {
        dictionary_detail(props.id).then((res) => {
          if (res.status == 200) state.model = res.data?.data;
        });
      }
    });

    const onLoadCate = () => {
      dictionary_cate_list().then((res) => {
        if (res.status == 200) {
          state.cateData = res.data?.data?.list || [];
        }
      });
    };

    const onCateChange = () => {
      delete state.model.pid;
      onLoadTree();
    };

    const onLoadTree = () => {
      dictionary_tree(state.model.dictionary_cate_id).then((res) => {
        if (res.status == 200) state.treeData = res.data?.data?.list || [];
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            dictionary_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            dictionary_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadTree,
      onLoadCate,
      onCateChange,
    };
  },
};
</script>
<style scoped></style>
